import React from "react";

import { SupHeading, SupText } from "@repo/core-ui";
import { SupPool } from "@repo/core-ui";

export default function UiLabelSuperPoolTooltip() {
  return (
    <div className="space-y-2">
      <div className="inline-flex w-full flex-nowrap items-center space-x-1 text-primary-600">
        <SupPool className="h-6 w-6 drop-shadow-md" />
        <SupHeading variant="h6">SuperPool</SupHeading>
      </div>
      <SupText variant="subtitle1" as="div" className="text-neutral-900">
        This vault has a SuperPool which can reduce your gas cost by over 99%.
      </SupText>
    </div>
  );
}
